export const formatNumber = (value) => {
    // Check if value is greater than or equal to 1000
    if (!isFinite(value)) return null;
    if (isFinite(value)) return value >= 1000 ? (value / 1000).toFixed(2) + 'K' : value.toString();
};
